import React, { memo, useCallback, useState } from "react";
import SearchIcon from "./images/icons/search.svg?react";
import CloseIcon from "@/common/images/icons/x.svg?react";
import { clsx } from "clsx";
import "./Search.scss";

type TSearchSize = "l" | "m" | "s" | "xs";

interface ISearch {
  onChange: (text: string) => void;
  value: string;
  disabled?: boolean;
  theme?: "light" | "dark";
  size?: TSearchSize;
}

export const Search: React.FC<ISearch> = memo(({
  onChange,
  value,
  disabled,
  theme = "dark",
  size = "m"
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  }, [onChange]);

  const handleClear = useCallback(() => {
    onChange("");
  }, [onChange]);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className={clsx(
      "Search",
      `Search_is${theme}`,
      `Search_${size}`,
      isFocused && "Search_isFocused",
      disabled && "Search_isDisabled",
      value && "Search_isFilled"
    )}>
      <span className="Search-Icon"><SearchIcon /></span>
      <input
        className="Search-Input"
        type="text"
        value={value}
        placeholder="Search..."
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
      />
      {value && <button className="Search-Close" onClick={handleClear}><CloseIcon className="CloseIcon" /></button>}
    </div>
  );
});
